import {StrictMode} from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from "react-router-dom";
import App from './App';
import './index.css';

console.log("[SYSTEM] Registry interface mounting initiated...");

// Pre-flight health check
const isCustomDomain = typeof window !== "undefined" && 
  !window.location.hostname.includes("run.app") && 
  !window.location.hostname.includes("localhost") && 
  !window.location.hostname.includes("127.0.0.1");

if (!isCustomDomain) {
  fetch("/api/health")
    .then(res => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const contentType = res.headers.get("content-type") || "";
      if (!contentType.includes("application/json")) {
        throw new Error("Response is not JSON");
      }
      return res.json();
    })
    .then(data => console.log("[SYSTEM] Node linked:", data.node))
    .catch(err => console.warn("[SYSTEM] Node connectivity weak:", err.message));
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error("[FATAL] DOM registry error: #root element not found.");
} else {
  try {
    createRoot(rootElement).render(
      <StrictMode>
        <BrowserRouter>
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </BrowserRouter>
      </StrictMode>,
    );
    console.log("[SYSTEM] Registry interface successfully rendered.");
  } catch (error) {
    console.error("[FATAL] Render cycle collapse:", error);
    rootElement.innerHTML = `
      <div style="background: black; color: red; padding: 2rem; font-family: monospace;">
        <h1>SYSTEM_BOOT_FAILURE</h1>
        <p>The interface rendering engine has collapsed.</p>
        <pre>${error instanceof Error ? error.stack : String(error)}</pre>
      </div>
    `;
  }
}
